import type React from "react";
import { useTranslation } from "react-i18next";
import type translations from "../../translations/translations.json";
import { TestId } from "../../constants/testIds";
import EntityChangeHistorySection from "../common/EntityChangeHistorySection";
import type { UangJalanReportHistory } from "../../types/uangJalanReport";
import { buildUangJalanReportDisplayHistories } from "../../utils/entityChangeHistory";

type TranslationKeys = keyof typeof translations.en;

interface UangJalanReportHistorySectionProps {
  histories: UangJalanReportHistory[];
}

const UangJalanReportHistorySection: React.FC<UangJalanReportHistorySectionProps> = ({
  histories,
}) => {
  const { t } = useTranslation();
  const sortedHistories = buildUangJalanReportDisplayHistories(histories);

  return (
    <EntityChangeHistorySection
      title={t("reports.histories" as TranslationKeys)}
      histories={sortedHistories}
      testIds={{
        root: TestId.UJR.STATUS_HISTORY,
        entry: TestId.UJR.HISTORY_ENTRY,
        summary: TestId.UJR.HISTORY_SUMMARY,
      }}
    />
  );
};

export default UangJalanReportHistorySection;
